/**
 * Pre-assignment bin sizes — keep in sync with api/PreAssignmentHelpers/bin-sizes.constants.js
 */
export const BIN_SIZE_CODE_TO_LABEL = {
  XS: 'X-Small',
  S: 'Small',
  M: 'Medium',
  L: 'Large',
  XL: 'Extra Large',
  MW: 'Medium Wide',
  SW: 'Slim Wide',
  LW: 'Large Wide',
};

export const SIZE_BASED_ASSIGN_BIN_SIZES = [
  'X-Small',
  'Small',
  'Medium',
  'Large',
  'Extra Large',
  'Medium Wide',
  'Slim Wide',
  'Large Wide',
];

/** Compact labels for availability summary UI */
export const BIN_SIZE_SHORT_LABEL = {
  'X-Small': 'XS',
  Small: 'S',
  Medium: 'M',
  Large: 'L',
  'Extra Large': 'XL',
  'Medium Wide': 'MW',
  'Slim Wide': 'SW',
  'Large Wide': 'LW',
};

/** Brand accent used across assign / unplugged flows (buttons, actions) */
export const PORTAL_BRAND_ACCENT_GREEN = '#6cca98';

export const LEGACY_ASSIGN_BIN_SIZES = ['Large', 'Medium', 'Small', 'Cool'];

const BIN_SIZE_COUNT_KEY_BY_LABEL = {
  'X-Small': 'xSmallCounts',
  Small: 'smallCounts',
  Medium: 'mediumCounts',
  Large: 'largeCounts',
  'Extra Large': 'extraLargeCounts',
  'Medium Wide': 'mediumWideCounts',
  'Slim Wide': 'slimWideCounts',
  'Large Wide': 'largeWideCounts',
};

const BIN_SIZE_I18N_KEY_BY_LABEL = {
  'X-Small': 'Unplugged.XSmallBinSize',
  Small: 'Unplugged.SmallBinSize',
  Medium: 'Unplugged.MediumBinSize',
  Large: 'Unplugged.LargeBinSize',
  'Extra Large': 'Unplugged.ExtraLargeBinSize',
  'Medium Wide': 'Unplugged.MediumWideBinSize',
  'Slim Wide': 'Unplugged.SlimWideBinSize',
  'Large Wide': 'Unplugged.LargeWideBinSize',
  Cool: 'Unplugged.CoolBinSize',
};

export const resolveBinSizeLabel = (input) => {
  if (input === undefined || input === null || input === '') {
    return null;
  }
  const raw = String(input).trim();
  const code = raw.toUpperCase();
  if (BIN_SIZE_CODE_TO_LABEL[code]) {
    return BIN_SIZE_CODE_TO_LABEL[code];
  }
  if (raw.toLowerCase() === 'cool') {
    return 'Extra Large';
  }
  const sizeMatch = SIZE_BASED_ASSIGN_BIN_SIZES.find(
    (label) => label.toLowerCase() === raw.toLowerCase(),
  );
  if (sizeMatch) {
    return sizeMatch;
  }
  return (
    LEGACY_ASSIGN_BIN_SIZES.find(
      (label) => label.toLowerCase() === raw.toLowerCase(),
    ) || null
  );
};

const pickBinCount = (data, key) => {
  if (!data) {
    return 0;
  }
  const camel = data[key];
  if (camel !== undefined && camel !== null && camel !== '') {
    return Number(camel);
  }
  const lower = data[key.toLowerCase()];
  if (lower !== undefined && lower !== null && lower !== '') {
    return Number(lower);
  }
  return 0;
};

/** Parse getAvailableBinsCount API payload for size-based assign UI. */
export const parseSizeBasedBinCounts = (data) => {
  const counts = {};
  SIZE_BASED_ASSIGN_BIN_SIZES.forEach((label) => {
    const key = BIN_SIZE_COUNT_KEY_BY_LABEL[label];
    counts[label] = pickBinCount(data, key);
  });
  return counts;
};

export const getBinSizeTranslationMap = (t) => {
  const map = {};
  [...SIZE_BASED_ASSIGN_BIN_SIZES, ...LEGACY_ASSIGN_BIN_SIZES].forEach(
    (label) => {
      const i18nKey = BIN_SIZE_I18N_KEY_BY_LABEL[label];
      map[label] = i18nKey ? t(i18nKey) : label;
    },
  );
  return map;
};

export const getBinCountStateKey = (label) => {
  const key = BIN_SIZE_COUNT_KEY_BY_LABEL[label];
  if (!key) {
    return null;
  }
  return `${key.replace(/Counts$/, '')}BinsCount`;
};



// WEBPACK FOOTER //
// ./src/utils/binSizes.js